var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "auth-layout" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSettingUp,
              expression: "!isSettingUp",
            },
          ],
          staticClass: "auth-container",
        },
        [
          _c("div", { staticClass: "auth-header" }, [
            _c("img", {
              staticClass: "auth-logo",
              attrs: { src: "/static/logo.png", alt: "Pitaya" },
              on: { error: _vm.handleLogoError },
            }),
            _vm._v(" "),
            _c("h1", { staticClass: "auth-title" }, [
              _vm._v(_vm._s(_vm.$t("auth.welcome"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "auth-content" }, [_c("router-view")], 1),
          _vm._v(" "),
          _c("div", { staticClass: "auth-footer" }, [
            _c("p", { staticClass: "copyright" }, [
              _vm._v(
                "\n        © " +
                  _vm._s(new Date().getFullYear()) +
                  " Pitaya. All rights reserved.\n      "
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isSettingUp
          ? _c(
              "div",
              {
                staticClass: "setup-overlay",
                attrs: { "aria-live": "polite" },
              },
              [
                _c("div", { staticClass: "setup-card" }, [
                  _c("span", { staticClass: "setup-loader" }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "setup-title" }, [
                    _vm._v("We're setting things up…"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "setup-subtitle" }, [
                    _vm._v("This will only take a few seconds."),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "auth-background" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }